import { Card, CardProps } from "antd";
import { FC } from "react";

export type IncCardProps = CardProps;

export const IncCard: FC<IncCardProps> = (props) => <Card {...props} />;
